import {useQuery} from "@tanstack/react-query";
import {getAvailableGroups} from "../services/GroupService";

// Groups available for a (user type, business unit), each carrying its `isDefault` flag and `claims`
// (TMMFX-2170 Change 4). Replaces the per-group claims fan-out for the create wizard's Step 3.
export function useAvailableGroups(userTypeId, businessUnitCode, enabled = true) {
    const {data, isLoading} = useQuery({
        queryKey: ["availableGroups", userTypeId, businessUnitCode],
        queryFn: () => getAvailableGroups(userTypeId, businessUnitCode),
        enabled: enabled && !!userTypeId && !!businessUnitCode,
        retry: false,
    });

    return {groups: data ?? [], isLoading};
}
